// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__E4_wt","author":"Table_author__2CtHT","authorImage":"Table_authorImage__265zS","unreadRow":"Table_unreadRow__3RZ09"};